// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Signature_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
const ethers_1 = require("ethers");
const typedjson_1 = require("../export/typedjson");
const util_1 = require("./util");
let Signature = Signature_1 = class Signature {
    constructor(value) {
        this.value = ethers_1.utils.arrayify(value);
    }
    toString() {
        return ethers_1.utils.hexlify(this.value);
    }
    static toJSON(me) {
        return ethers_1.utils.hexlify(me.value);
    }
    static fromJSON(val) {
        return new Signature_1(val);
    }
    asABI() {
        return this.value;
    }
    ABIType() {
        return "bytes";
    }
};
Signature = Signature_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [Object])
], Signature);
exports.Signature = Signature;
util_1.customJSON(Signature);
//# sourceMappingURL=signature.js.map